export default function unique(objs) {
  return Array.from(new Set(objs));
}
